export default __webpack_public_path__ + "static/media/manzil_image2.png.webp";